// import { HttpStatusCode } from 'axios';
import Http from "../../http";

class RiderServices {
  static async getNearestRiders(data) {
    return Http.post('/rider/nearest-riders', data);
  }
  static async findRiderById(id) {
    return Http.get(`/rider/${id}`);
  }
  static async fetchAllRiders() {
    return Http.get('/rider/fetchAllRiders');
  }
  //Added by Raj
  static async updateRiderByPhoneNumber(data) {
    return Http.update('/rider/byPhoneNumber', data);
  }

  static async updateRiderAddBookedDate(data) {
    return Http.update('/rider/addBookedDate', data);
  }

  static async updateRiderRemoveBookedDate(data) {
    return Http.update('/rider/removeBookedDate', data);
  }
}

export default RiderServices;
